"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddressFromPrivateKey = exports.getPublicKeyFromPrivateKey = exports.verifyPubKeyAgainstThresholdPubKey = exports.deriveKeyForCurrentCombination = exports.getCurrentCombinationShares = exports.getDecryptedShareFromResponse = exports.createMultipleShareRequests = exports.decryptShare = exports.createShareRequest = exports.createShareCommitments = exports.createShareCommitmentRequest = exports.KeyReconstructor = void 0;
const buffer_1 = require("buffer");
const helper_1 = require("./helper");
const ssrHelper_1 = require("./ssrHelper");
const eccrypto_1 = require("eccrypto");
const web3_utils_1 = require("web3-utils");
const elliptic_1 = require("elliptic");
const nodes_1 = __importDefault(require("./nodes"));
const bn_js_1 = __importDefault(require("bn.js"));
const logger_1 = require("./logger");
const ec = new elliptic_1.ec('secp256k1');
class KeyReconstructor {
    constructor(config, dkg) {
        this.getPublicKey = ({ id, verifier, }) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            try {
                const requestObj = (0, helper_1.generateJsonRPCObject)('VerifierLookupRequest', {
                    verifier,
                    verifier_id: id,
                    app_id: this.appID,
                });
                const { nodes } = yield this.nodeList.getNodes();
                const data = yield (0, helper_1.post)(nodes[0], requestObj);
                this.logger.info('get_public_key', { data });
                if (data.ok) {
                    if (data.response.error) {
                        yield this.assignKey(verifier, id);
                        return this.getPublicKey({ verifier, id });
                    }
                    else {
                        const { pub_key_X: X, pub_key_Y: Y } = (_b = (_a = data.response) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.keys[0];
                        return { X, Y };
                    }
                }
                else {
                    return Promise.reject('Error during getting public key');
                }
            }
            catch (error) {
                this.logger.error('get_public_key', { error: error.toString() });
                return Promise.reject('Error during getting public key');
            }
        });
        this.getPrivateKey = ({ id, verifier, idToken, }) => __awaiter(this, void 0, void 0, function* () {
            try {
                if (!idToken || !id || !verifier) {
                    throw new Error('Missing parameters!');
                }
                yield this.getPublicKey({ verifier, id });
                const key = (0, eccrypto_1.generatePrivate)();
                const [publicKey, tokenCommitment] = [
                    (0, exports.getPublicKeyFromPrivateKey)(key),
                    (0, web3_utils_1.keccak256)(idToken),
                ];
                this.logger.debug(`TempCreds`, {
                    key: key.toString('hex'),
                    publicKey,
                });
                const { nodes, indexes } = yield this.nodeList.getNodes();
                const commitments = yield (0, exports.createShareCommitments)({
                    verifier,
                    publicKey,
                    tokenCommitment,
                }, nodes);
                const derivedPk = yield getPrivateKeyFromShares({
                    verifier,
                    id,
                    key,
                    idToken,
                    commitments,
                    appID: this.appID,
                }, { nodes, indexes });
                return derivedPk;
            }
            catch (e) {
                this.logger.error('get_private_key', { e });
                return Promise.reject(e.message);
            }
        });
        this.assignKey = (verifier, id) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestObj = (0, helper_1.generateJsonRPCObject)('KeyAssign', {
                    verifier,
                    verifier_id: id,
                    app_id: this.appID,
                });
                const { nodes } = yield this.nodeList.getNodes();
                const assignKeyResult = yield (0, helper_1.post)(nodes[0], requestObj);
                if (!(assignKeyResult === null || assignKeyResult === void 0 ? void 0 : assignKeyResult.ok)) {
                    this.logger.error('assign_key_result_error', {
                        error: assignKeyResult.response,
                    });
                    return Promise.reject('Error during key assignment');
                }
                return assignKeyResult;
            }
            catch (e) {
                this.logger.error('assign_key_result_error', { e });
                return Promise.reject('Error during key assignment');
            }
        });
        this.appID = config.appID;
        this.network = config.network ? config.network : 'test';
        if (this.network === 'test') {
            (0, logger_1.setLogLevel)(logger_1.LOG_LEVEL.DEBUG);
            (0, logger_1.setExceptionReporter)((0, helper_1.getSentryErrorReporter)());
        }
        else {
            (0, logger_1.setLogLevel)(logger_1.LOG_LEVEL.ERROR);
        }
        this.nodeList = dkg ? dkg : new nodes_1.default(this.network);
        this.logger = (0, logger_1.getLogger)('KeyReconstructor');
    }
}
exports.KeyReconstructor = KeyReconstructor;
const createShareCommitmentRequest = (node, body, p = helper_1.post) => __awaiter(void 0, void 0, void 0, function* () {
    const { response } = yield (0, helper_1.post)(node, body);
    if (response.error) {
        throw new Error(response.error.data);
    }
    else {
        return response;
    }
});
exports.createShareCommitmentRequest = createShareCommitmentRequest;
const createShareCommitments = ({ verifier, publicKey, tokenCommitment }, nodes) => __awaiter(void 0, void 0, void 0, function* () {
    const logger = (0, logger_1.getLogger)('CreateShareCommitments');
    try {
        const body = (0, helper_1.generateJsonRPCObject)('CommitmentRequest', {
            messageprefix: 'arc00',
            tokencommitment: tokenCommitment.slice(2),
            temppubx: publicKey.X,
            temppuby: publicKey.Y,
            verifieridentifier: verifier,
        });
        const promises = [];
        for (let i = 0; i < nodes.length; i++) {
            const requestPromise = (0, exports.createShareCommitmentRequest)(nodes[i], body);
            promises.push(requestPromise);
        }
        const responsesArr = yield Promise.all(promises);
        if (responsesArr.length >= ~~(nodes.length / 4) * 3 + 1) {
            return Promise.resolve(responsesArr);
        }
        else {
            logger.error('did_not_receive_length_shares', {
                responses: responsesArr,
            });
            return Promise.reject(`did not receive correct shares`);
        }
    }
    catch (e) {
        logger.error('createShareCommitments', { e: e.message });
        return Promise.reject(e);
    }
});
exports.createShareCommitments = createShareCommitments;
const createShareRequest = ({ verifier, node, id, idToken, nodeSigs, appID, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { response } = yield (0, helper_1.post)(node, (0, helper_1.generateJsonRPCObject)('ShareRequest', {
        encrypted: 'yes',
        item: [
            {
                verifier_id: id,
                idtoken: idToken,
                nodesignatures: nodeSigs,
                verifieridentifier: verifier,
                app_id: appID,
            },
        ],
    }));
    if (response.error) {
        const logger = (0, logger_1.getLogger)('CreateShareRequest');
        logger.error('dkg_error', { response });
        return Promise.reject(((_a = response.error) === null || _a === void 0 ? void 0 : _a.data) || ((_b = response.error) === null || _b === void 0 ? void 0 : _b.message));
    }
    else {
        return response;
    }
});
exports.createShareRequest = createShareRequest;
const decryptShare = (keyItem, key) => {
    if (keyItem.metadata) {
        const { iv, mac, mode, ephemPublicKey } = keyItem.metadata;
        const { share } = keyItem;
        const fromHex = (h) => buffer_1.Buffer.from(h, 'hex');
        const metadata = {
            ephemPublicKey: fromHex(ephemPublicKey),
            iv: fromHex(iv),
            mac: fromHex(mac),
            mode: fromHex(mode),
            ciphertext: fromHex(atob(share).padStart(64, '0')),
        };
        return (0, eccrypto_1.decrypt)(key, metadata);
    }
    else {
        return Promise.resolve(buffer_1.Buffer.from(keyItem.share.padStart(64, '0'), 'hex'));
    }
};
exports.decryptShare = decryptShare;
const getPrivateKeyFromShares = (params, nodeInfo) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { nodes, indexes } = nodeInfo;
        const thresholdCount = ~~(nodes.length / 2) + 1;
        const promises = (0, exports.createMultipleShareRequests)(nodes, params);
        return handleThresholdResponse(promises, {
            key: params.key,
            thresholdCount,
            indexes,
        });
    }
    catch (error) {
        const logger = (0, logger_1.getLogger)('GetPrivateKeyFromShares');
        logger.error('get_private_key_from_shares', { error });
        return null;
    }
});
const createMultipleShareRequests = (nodes, createShareRequestParams) => {
    const { commitments } = createShareRequestParams, params = __rest(createShareRequestParams, ["commitments"]);
    const nodeSigs = [];
    const promises = [];
    for (const c of commitments) {
        nodeSigs.push(c.result);
    }
    for (const node of nodes) {
        const p = (0, exports.createShareRequest)(Object.assign(Object.assign({}, params), { node,
            nodeSigs }));
        promises.push(p);
    }
    return promises;
};
exports.createMultipleShareRequests = createMultipleShareRequests;
const handleThresholdResponse = (promises, params) => {
    const { thresholdCount, indexes, key } = params;
    return (0, helper_1.afterThreshold)(promises, thresholdCount, (shareResponses) => __awaiter(void 0, void 0, void 0, function* () {
        const logger = (0, logger_1.getLogger)('HandleThresholdResponse');
        logger.info('Share responses', shareResponses);
        const completedRequests = shareResponses.filter((x) => x);
        const thresholdPublicKey = (0, helper_1.thresholdSame)(shareResponses.map((x) => { var _a, _b; return (_b = (_a = x === null || x === void 0 ? void 0 : x.result) === null || _a === void 0 ? void 0 : _a.keys[0]) === null || _b === void 0 ? void 0 : _b.pub_key; }), thresholdCount);
        if (completedRequests.length >= thresholdCount && thresholdPublicKey) {
            const decryptedShares = yield (0, exports.getDecryptedShareFromResponse)(shareResponses, key, indexes);
            const combinations = (0, ssrHelper_1.getAllCombinations)(decryptedShares.length, thresholdCount);
            let privateKey;
            for (let j = 0; j < combinations.length; j += 1) {
                const selectedShares = (0, exports.getCurrentCombinationShares)(decryptedShares, combinations[j]);
                const { privateKey: derivedPrivateKey, publicKey, } = (0, exports.deriveKeyForCurrentCombination)(selectedShares);
                const isVerified = (0, exports.verifyPubKeyAgainstThresholdPubKey)(publicKey, thresholdPublicKey);
                logger.info('Compare pub key to derived', { isVerified });
                if (isVerified) {
                    privateKey = derivedPrivateKey;
                    break;
                }
            }
            if (privateKey === undefined) {
                throw new Error('could not derive private key');
            }
            const publicKey = (0, exports.getPublicKeyFromPrivateKey)(privateKey);
            return {
                address: (0, exports.getAddressFromPrivateKey)(privateKey.toString('hex')),
                privateKey: privateKey.toString('hex', 64),
                publicKey: publicKey.X + publicKey.Y,
            };
        }
        throw new Error('Not yet!');
    }));
};
const getDecryptedShareFromResponse = (shareResponses, key, indexes) => __awaiter(void 0, void 0, void 0, function* () {
    var _c, _d, _e;
    const sharePromises = [];
    const nodeIndex = [];
    for (let i = 0; i < shareResponses.length; i += 1) {
        if (((_e = (_d = (_c = shareResponses[i]) === null || _c === void 0 ? void 0 : _c.result) === null || _d === void 0 ? void 0 : _d.keys) === null || _e === void 0 ? void 0 : _e.length) > 0) {
            shareResponses[i].result.keys.sort((a, b) => new bn_js_1.default(a.index, 16).cmp(new bn_js_1.default(b.index, 16)));
            sharePromises.push((0, exports.decryptShare)(shareResponses[i].result.keys[0], key));
        }
        else {
            sharePromises.push(Promise.resolve(undefined));
        }
        nodeIndex.push(new bn_js_1.default(indexes[i], 16));
    }
    const sharesResolved = yield Promise.all(sharePromises);
    const logger = (0, logger_1.getLogger)('getDecryptedShareFromResponse');
    logger.info('Share responses', sharesResolved);
    const decryptedShares = sharesResolved.reduce((acc, curr, index) => {
        if (curr)
            acc.push({ index: nodeIndex[index], value: new bn_js_1.default(curr) });
        return acc;
    }, []);
    return decryptedShares;
});
exports.getDecryptedShareFromResponse = getDecryptedShareFromResponse;
const getCurrentCombinationShares = (decryptedShares, currentCombi) => {
    const currentCombiShares = decryptedShares.filter((v, index) => currentCombi.includes(index));
    return currentCombiShares;
};
exports.getCurrentCombinationShares = getCurrentCombinationShares;
const deriveKeyForCurrentCombination = (currentCombiShares) => {
    const logger = (0, logger_1.getLogger)('deriveKeyForCurrentCombination');
    const { shares, indices } = getSharesAndIndices(currentCombiShares);
    // logger.info('privateKey', { privateKey: privateKey.toString('hex') });
    const privateKey = (0, ssrHelper_1.lagrangeInterpolation)(shares, indices);
    logger.debug('privateKey', { privateKey: privateKey.toString('hex') });
    const publicKey = (0, exports.getPublicKeyFromPrivateKey)(privateKey);
    return { privateKey, publicKey };
};
exports.deriveKeyForCurrentCombination = deriveKeyForCurrentCombination;
const getSharesAndIndices = (s) => {
    const shares = s.map((x) => x.value);
    const indices = s.map((x) => x.index);
    return { shares, indices };
};
const verifyPubKeyAgainstThresholdPubKey = (publicKey, thresholdPublicKey) => {
    const thresholdX = new bn_js_1.default(thresholdPublicKey.pub_x, 10);
    const thresholdY = new bn_js_1.default(thresholdPublicKey.pub_y, 10);
    return (new bn_js_1.default(publicKey.X, 16).cmp(thresholdX) === 0 &&
        new bn_js_1.default(publicKey.Y, 16).cmp(thresholdY) === 0);
};
exports.verifyPubKeyAgainstThresholdPubKey = verifyPubKeyAgainstThresholdPubKey;
const getPublicKeyFromPrivateKey = (privateKey) => {
    const logger = (0, logger_1.getLogger)('getPublicKeyFromPrivateKey');
    logger.debug('privateKey', { privateKey: privateKey.toString('hex') });
    let buffer;
    if (!(privateKey instanceof buffer_1.Buffer)) {
        buffer = buffer_1.Buffer.from(privateKey.toString(16, 64), 'hex');
    }
    else {
        buffer = privateKey;
    }
    const decryptedPubKey = (0, eccrypto_1.getPublic)(buffer).toString('hex');
    const X = decryptedPubKey.slice(2, 66);
    const Y = decryptedPubKey.slice(66);
    return {
        X,
        Y,
    };
};
exports.getPublicKeyFromPrivateKey = getPublicKeyFromPrivateKey;
const getAddressFromPrivateKey = (pk) => {
    const key = ec.keyFromPrivate(pk, 'hex');
    const publicKey = key
        .getPublic()
        .encode('hex')
        .slice(2);
    const ethAddressLower = `0x${(0, web3_utils_1.keccak256)(publicKey).slice(64 - 38)}`;
    return (0, web3_utils_1.toChecksumAddress)(ethAddressLower);
};
exports.getAddressFromPrivateKey = getAddressFromPrivateKey;
exports.default = KeyReconstructor;
